import React from 'react';
import { useHistory } from "react-router-dom";

import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles({
  buttonLogin: {
    marginRight: '15px',
  },
  buttonLogout: {
    background: 'linear-gradient(-45deg, #00b2ad 30%, #31a9e0 90%)',
    color: "#fff"
  }
});

export default (props) => {

  const history = useHistory();

  const Login = async () => {
    history.push("/login");
  }

  const Register = async () => {
    history.push("/register");
  }

  const classes = useStyles();
  return (
    <div className="banner">
      <Container>
        <Grid container direction="row" justify="space-between" alignItems="flex-end">
          <Grid item><a href="/"><img id="logo-corrivium" src={process.env.PUBLIC_URL + '/corrivium.png'} alt="Corrivium Live" /></a></Grid>
          <Grid item>
            {props.isAuthenticated ? (
              <div>
                <Button color="primary" variant="contained" className={classes.buttonLogout} onClick={() => props.Logout()}>Logout</Button>
              </div>
            ) : (
              <div>
                <Button color="default" className={classes.buttonLogin} onClick={() => Login()}>Login</Button>
                <Button color="secondary" variant="contained" onClick={() => Register()}>Register</Button>
              </div>
            )}
        </Grid>
        </Grid>
      </Container>
    </div >
  );
}
